import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { GraphQLError } from 'graphql';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ToastSeverity } from '../notification/notification.component';
import { VehicleTypeService } from '../services/vehicle-type.service';
import { SelectedModificationService } from '../services/selected-modification.service';
import { VehicleType } from '../dialogs/add-vehicle-form/vehcle-type.interfaces';
interface IGraphQlResponseBodyErrors {
  errors?: GraphQLError[]; // Optional property with array of GraphQLError
}

export function mainInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const platformId = inject(PLATFORM_ID);
  const messageService = inject(MessageService);
  const vehicleTypeService = inject(VehicleTypeService);
  const selectedModificationService = inject(SelectedModificationService);

 let selectedVehicleType = vehicleTypeService.currentVehicleType;
 let selectedModificationId = selectedModificationService.selectedModificationId;

  // Add the global URL parameter
  const globalParams: any = {
    vehicleType: selectedVehicleType || VehicleType.Passenger, // Use default value if null
  };
  
  // Add modificationId only if it's not null

  if (selectedModificationId !== null && selectedModificationId !== undefined) {
    globalParams.modificationId = selectedModificationId;
  }
  
  const modifiedReq = req.clone({
    setParams: globalParams,
  });

  return next(modifiedReq).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        handleGraphqlHttpResponse200Errors(messageService, platformId, event);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      return handleHttpError(messageService, platformId, error); // Return the observable returned by handleHttpError
    })
  );
}

export function handleGraphqlHttpResponse200Errors(
  messageService: MessageService,
  platformId: {},
  response: any
) {
  // GraphQL errors still return 200 OK responses, but have the actual error message
  // inside the body of the response.

  const graqhQLErrors: IGraphQlResponseBodyErrors = response.body.errors;
  if (graqhQLErrors && Array.isArray(graqhQLErrors)) {
    const firstCode: string = graqhQLErrors[0].extensions.code;
    if (firstCode === 'FORBIDDEN') {
      const message = graqhQLErrors.map((err) => err.message).join('\n');

      displayErrorNotification(messageService, platformId, undefined, message);
      // auto logout needed?
    } else if (firstCode === 'CHANNEL_NOT_FOUND') {
      const message = graqhQLErrors.map((err) => err.message).join('\n');

      displayErrorNotification(messageService, platformId, undefined, message);
    } else {
      const message = graqhQLErrors.map((err) => err.message).join('\n');

      displayErrorNotification(messageService, platformId, undefined, message);
    }
  }
}
export function handleHttpError(
  messageService: MessageService,
  platformId: {},
  httpErrorResponse: HttpErrorResponse
): Observable<HttpEvent<unknown>> {
  if (httpErrorResponse.error.statusCode === 0) {
    displayErrorNotification(
      messageService,
      platformId,
      httpErrorResponse,
      'Could not connect to server!'
    );
  } else {
    displayErrorNotification(messageService, platformId, httpErrorResponse);
  }

  return throwError(httpErrorResponse);
}

/**
 * We need to lazily inject the NotificationService since it depends on the I18nService which
 * eventually depends on the HttpClient (used to load messages from json files). If we were to
 * directly inject NotificationService into the constructor, we get a cyclic dependency.
 */

export function displayErrorNotification(
  messageService: MessageService,
  platformid: {},
  httpErrorResponse?: HttpErrorResponse,
  customMessage?: string
): void {
  if (isPlatformBrowser(platformid)) {
    if (customMessage) {
      messageService.add({
        severity: ToastSeverity.Error,
        key: 'notifications',
        summary: 'HTTP ERROR',
        detail: customMessage,
      });
    } else if (httpErrorResponse) {
      messageService.add({
        severity: ToastSeverity.Error,
        key: 'notifications',
        summary: httpErrorResponse.name || 'HTTP ERROR',
        detail: httpErrorResponse.error.message || customMessage,
      });
    }
  }

  //  const notificationService = this.injector.get<NotificationService>(NotificationService);
  //   notificationService.error(message).subscribe();
}
